module.exports = __webpack_public_path__ + "static/media/michael.fbb00bfe.jpg";